// ============================================================
// billingUnits.ts — the billing unit rule, frontend twin of the backend's
// lib/billing.ts. UK legal standard: 6-MINUTE units (1/10 hour), ROUNDED UP.
//   units = ceil(seconds / 360)   (0s → 0; 1s–6m → 1; 6m01s → 2)
// The server charges units × round(hourlyRate ÷ 10), so the units shown here
// are exactly the units charged on new entries (screen + charge agree).
// A manual units override is stored as units × 360 seconds, which maps back
// to exactly those units.
// ============================================================
export const SECONDS_PER_UNIT = 360

export const billableUnits = (seconds: number): number =>
  seconds > 0 ? Math.ceil(seconds / SECONDS_PER_UNIT) : 0

/** Whole units typed in the override box → stored seconds (fractions round UP). */
export const unitsToSeconds = (units: number): number =>
  units > 0 ? Math.ceil(units - 1e-9) * SECONDS_PER_UNIT : 0

/** "1 unit" / "3 units". */
export const unitsLabel = (units: number): string => `${units} unit${units === 1 ? '' : 's'}`
